export type OrderDetailsList = {
  pagingMetadata: {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
  orderList: OrderDetails[];
  customerArInfo: {
    currentAmountDue: string;
    daysAmountDue1_30: string;
    daysAmountDue30_60: string;
    daysAmountDue60Plus: string;
    daysAmountDue60_90: string;
    daysAmountDue90Plus: string;
  };
};

export type OrderDetails = {
  orderId: number;
  orderNo: string;
  accountNo: string;
  orderByEmail: string;
  ro: string;
  po: string;
  requestedDate: string;
  statusId: number;
  status: string;
  orderImages: OrderImageDetails[];
};

export type OrderImageDetails = {
  attachmentID: number;
  fileUrl: string;
};

export type OrderHistoryState = {
  data: OrderDetailsList;
  loading: boolean;
  error: string | null;
};

export const initialState: OrderHistoryState = {
  data: {
    pagingMetadata: {
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false,
    },
    orderList: [],
    customerArInfo: {
      currentAmountDue: "0",
      daysAmountDue1_30: "0",
      daysAmountDue30_60: "0",
      daysAmountDue60Plus: "0",
      daysAmountDue60_90: "0",
      daysAmountDue90Plus: "0",
    },
  },
  loading: false,
  error: null,
};

export type OrderHistoryServiceOperators = {
  orderDetailsList: OrderDetailsList;
  fetchAllOrderHistoryInfo: (data: OrderHistoryPayload) => void;
};

export type OrderHistoryPayload = {
  FromDate: string;
  ToDate: string;
  AccountNo: string;
  Status: number[];
  PageNumber: number;
  PageSize: number;
  OrderByColumn: string;
  OrderBy: string;
  PoNo: string;
  RoNo: string;
  CompanyCode: string;
};

export type OrderHistoryForm = {
  FromDate: string;
  ToDate: string;
  AccountNo: string;
  Status: { id: number; label: string; value: number };
  DateRange: { id: number; label: string; value: number };
  PONo: string;
  RONo: string;
};

export type ImagesPayload = {
  orderId: number;
  orderAttachmentId: number;
};

export type ImageDetails = {
  fileUrl: string;
  fileBase64Content: string;
  createdUser: string;
  createdUser_Id: number;
  createdDate: string;
  orderAttachmentID: number;
  fileName: string;
  isEmailContent: boolean;
  isActive: boolean;
};

export type ImagesServiceOperators = {
  imageDetails: ImageDetails;
  fetchOrderHistoryImageInfo: (data: ImagesPayload) => void;
};
